// All Shared Reducers
import { system } from "./system.reducer";
import { authentication } from "./authentication.reducer";
import { emailVerificationReducer } from "./emailVerification.reducer";

//All Reducers related to admin screens.
import adminReducers from "../../views/admin-screens/redux/reducers";
//All Reducers related to brand screens.
import brandReducers from "../../views/brand-screens/redux/reducers";
//All Reducers related to group screens.
import groupReducers from "../../views/group-screens/redux/reducers";
//All Reducers related to manager screens.
import managerReducers from "../../views/manager-screens/redux/reducers";
//All Reducers related to shared screens.
import sharedReducers from "../../views/shared-screens/redux/reducers";

const allReducers = {
  system,
  authentication,
  emailVerificationReducer,

  ...adminReducers,
  ...brandReducers,
  ...groupReducers,
  ...managerReducers,
  ...sharedReducers,
};

export default allReducers;
